import { render } from "./WhistlesSectionComponent.vue?vue&type=template&id=32727519&ts=true"
import script from "./WhistlesSectionComponent.vue?vue&type=script&lang=ts"
export * from "./WhistlesSectionComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__